import { isFeatureEnabled } from 'owa-feature-flags';
import { getSelectedTableView } from 'owa-mail-list-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';

export default function isStickyNotesFolder(): boolean {
    const selectedTable = getSelectedTableView();
    return (
        selectedTable &&
        isFeatureEnabled('notes-folder-view') &&
        selectedTable.tableQuery.folderId === folderNameToId('notes')
    );
}
